'use es6';

export const LAYOUT_URL = 'designmanager/v1/layouts/unified/';